// Newsletter popup

document.addEventListener("DOMContentLoaded", function () {
  const popupBtn = document.querySelector(".newsletter-popup-button");
  const closeBtn = document.querySelector(".close-popup-btn");
  const overlay = document.querySelector(".newsletter-popup-overlay");

  if (popupBtn && overlay) {
    popupBtn.addEventListener("click", function () {
      overlay.classList.add("active");
    });
  }

  if (closeBtn && overlay) {
    closeBtn.addEventListener("click", function () {
      overlay.classList.remove("active");
    });
  }
});


//Submenu animation

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.menu-drawer__menu-item.list-menu__item').forEach(item => {
    const submenu = item.nextElementSibling;
    if (!submenu || !submenu.classList.contains('menu-drawer__submenu')) return;

    let timer;

    const open = () => {
      clearTimeout(timer);
      document.querySelectorAll('.menu-drawer__submenu.open').forEach(el => {
        if (el !== submenu) {
          el.classList.remove('open');
          el.previousElementSibling?.classList.remove('open');
        }
      });
      submenu.classList.add('open');
      item.classList.add('open');
    };

    const close = () => {
      timer = setTimeout(() => {
        submenu.classList.remove('open');
        item.classList.remove('open');
      }, 200);
    };

    item.addEventListener('mouseenter', open);
    item.addEventListener('mouseleave', close);
    submenu.addEventListener('mouseenter', () => clearTimeout(timer));
    submenu.addEventListener('mouseleave', close);
  });
});

//footer menu mobile  accordion

document.addEventListener('DOMContentLoaded', function () {
  const toggles = document.querySelectorAll('.accordion-toggle');

  toggles.forEach(toggle => {
    toggle.addEventListener('click', function () {
      const contentWrapper = this.nextElementSibling;

      toggles.forEach(otherToggle => {
        const otherContent = otherToggle.nextElementSibling;

        if (otherToggle !== this) {
          otherToggle.classList.remove('active');
          otherContent.classList.remove('open');
        }
      });

      this.classList.toggle('active');
      contentWrapper.classList.toggle('open');
    });
  });
});

//Header color logic

document.addEventListener('DOMContentLoaded', function () {
  const headerColorControl = document.getElementById('header-color-control');
  const header = document.querySelector('.header-wrapper');

  if (headerColorControl && header) {
    const scheme = headerColorControl.dataset.headerColorScheme;
    if (scheme) {
      header.classList.add(scheme); 
    }
  }
});

//Gallery animation

document.addEventListener('DOMContentLoaded', function () {
  const cards = document.querySelectorAll('.gallery-card');

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('in-view');
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.1
  });

  cards.forEach(card => observer.observe(card));
});

// Product page function



document.addEventListener('DOMContentLoaded', function () {
  const svgWrappers = document.querySelectorAll('.product__info-wrapper__action .svg-wrapper');

  svgWrappers.forEach(function (svgWrapper) {
    svgWrapper.addEventListener('click', function () {
      const actionWrapper = svgWrapper.closest('.product__info-wrapper__action');
      const parentActionWrapper = svgWrapper.closest('.product__info-wrapper');

      if (actionWrapper && parentActionWrapper) {
        parentActionWrapper.classList.toggle('animate-hide');
        actionWrapper.classList.toggle('hide');
      }
    });
  });
});



document.addEventListener('DOMContentLoaded', function () {
  const readMoreBtn = document.querySelector('.read-more-button');
  const truncated = document.querySelector('.truncated-description');
  const full = document.querySelector('.full-description');

  if (readMoreBtn && truncated && full) {
    readMoreBtn.addEventListener('click', function () {
      truncated.style.display = 'none';
      full.classList.remove('hidden');
      readMoreBtn.style.display = 'none';
    });
  }
});

document.querySelectorAll('.product_inner_accordion .summary__title').forEach(header => {
  header.addEventListener('click', function () {
    const parent = this.parentElement;
    const isActive = parent.classList.contains('active');

    document.querySelectorAll('.product_inner_accordion').forEach(acc => {
      acc.classList.remove('active');
      acc.querySelector('.accordion_content').style.maxHeight = null;
    });

    if (!isActive) {
      parent.classList.add('active');
      const content = parent.querySelector('.accordion_content');
      content.style.maxHeight = content.scrollHeight + "px";
    }
  });
});

// document.addEventListener('DOMContentLoaded', function () {
//   let previousVariantId = null;

//   const blackShoeVariants = ['50721659355473'];
//   const whiteShoeVariants = ['51573741289809'];

//   const productMediaList = document.querySelector('.product__media-list');

//   function updateClassFromVariant() {
//     const variantId = String(new URLSearchParams(window.location.search).get('variant'));

//     if (!variantId || variantId === previousVariantId || !productMediaList) return;

//     productMediaList.classList.remove('black', 'white');

//     if (blackShoeVariants.includes(variantId)) {
//       productMediaList.classList.add('black');
//     } else if (whiteShoeVariants.includes(variantId)) {
//       productMediaList.classList.add('white');
//     } else {
//       console.log('No match for variantId:', variantId);
//     }

//     previousVariantId = variantId;
//   }

//   updateClassFromVariant();
//   setInterval(updateClassFromVariant, 500);
// });

document.addEventListener('DOMContentLoaded', function () {
  let previousVariantId = null;

  const productVariants = {
    product1: {
      black: ['50721659355473'],
      white: ['51573741289809', '51573741322577', '51573741355345', '51573741388113', '51573741420881', '51573741453649', '51573741486417', '51573741519185', '51573742666065', '51573742698833', '51573742731601', '51573742764369', '51573742797137', '51573742829905'],
    },
    product2: {
      black: ['51575772676433'],
      white: ['51575776772433','51576922571089','51576922603857','51576922636625','51576922669393','51576922702161','51576922734929','51576922767697','51576922800465','51576922833233','51576922866001','51576922898769','51576922931537','51576922964305'],
    },
    product3: {
      black: ['51574730621265'],
      white: ['51575262380369','51575262413137','51575262445905','51575262478673','51575262511441','51575262544209','51575262576977','51575262609745','51575262642513','51575262675281','51575262708049','51575262740817','51575262773585','51575262806353'],
    },
     product4: {
      black: ['51573721923921'],
      white: ['51573722480977','51573722513745','51573722546513','51573722579281','51573722612049','51573722644817','51573722677585','51573722710353','51573722743121','51573722775889','51573722808657','51573722841425','51573722874193','51573722906961'],
    },
  };

  const productMediaList = document.querySelector('.product__media-list');

  function updateClassFromVariant() {
    const variantId = String(new URLSearchParams(window.location.search).get('variant'));

    if (!variantId || variantId === previousVariantId || !productMediaList) return;

    productMediaList.classList.remove('black', 'white');

    let matched = false;

    for (const product in productVariants) {
      const { black, white } = productVariants[product];

      if (black.includes(variantId)) {
        productMediaList.classList.add('black');
        matched = true;
        break;
      } else if (white.includes(variantId)) {
        productMediaList.classList.add('white');
        matched = true;
        break;
      }
    }

    if (!matched) {
      console.log('No match for variantId:', variantId);
    }

    previousVariantId = variantId;
  }

  updateClassFromVariant();
  setInterval(updateClassFromVariant, 500);
});



